import React from 'react'
import PropTypes from 'prop-types'
import colors from '@settings/styleSettings'

import Text from './Text'

const styles = {
  title: {
    fontFamily: 'Inter-Regular',
    color: colors.strongGray,
    fontSize: '14px',
    marginBottom: 2,
  },
  value: {
    marginTop: 0,
    fontSize: '16px',
    fontFamily: 'Inter-Bold',
    fontStyle: 'normal',
    fontWeight: 600,
  },
}

export const Item = ({
  label, textColor, text, width, marginRight
}) => (
  <div style={{ width, marginRight }}>
    <Text style={styles.title}>{label}</Text>
    <Text style={{ ...styles.value, color: textColor }}>{text}</Text>
  </div>
)

Item.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  textColor: PropTypes.string,
  width: PropTypes.number,
  marginRight: PropTypes.number,
}

Item.defaultProps = {
  textColor: colors.titleStrongBlack,
  width: 162,
  marginRight: 32,
}
